<template>
  <div>
    <terms-dialog
      :show="showTermsDialog"
      :type="termsType"
      @close="onTermsDialogClose"
      :update="true"
    />

    <v-dialog :value="value" @input="close" max-width="600px" :persistent="loading">
      <v-form ref="form" @submit.prevent="submit">
        <v-card>
          <v-card-title>
            <span
              class="headline"
              v-text="
                showForgotPassword
                  ? $t('COMMON.FORGOT_PASSWORD')
                  : $t('COMMON.LOGIN')
              "
            ></span>
            <v-spacer />
            <tk-btn :disabled="loading" icon @click="close">
              <v-icon>fas fa-times</v-icon>
            </tk-btn>
          </v-card-title>
          <v-card-text v-if="title">
            <v-container class="py-0">
              <v-layout wrap>
                <v-flex xs12>
                  <div class="text-xs-center">
                    {{title}}
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-text>
            <v-alert
              v-if="error"
              :value="true"
              dismissible
              type="error"
              @input="error = null"
            >{{ error.message }}</v-alert>

            <v-alert
              v-if="resetSuccess"
              :value="true"
              dismissible
              type="success"
              @input="resetSuccess = false"
            >{{ $t("SIGNUP.MSG_RESET_PASSWORD_SUCCESS") }}</v-alert>

            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    :error="!!error"
                    :label="$t('COMMON.EMAIL') + '*'"
                    autocomplete="username"
                    v-model="form.email"
                    type="email"
                    prepend-icon="fas fa-at"
                    required
                  />
                </v-flex>
                <v-flex xs12 v-if="!showForgotPassword">
                  <v-text-field
                    :error="!!error"
                    :label="$t('COMMON.PASSWORD') + '*'"
                    autocomplete="current-password"
                    v-model="form.password"
                    type="password"
                    prepend-icon="fas fa-key"
                    required
                  />
                </v-flex>
              </v-layout>
            </v-container>
            <v-layout wrap>
              <v-flex sm10>
                <tk-btn flat small :to="{ name: 'signup' }" @click="close">
                  <span class="caption text-none">
                    {{
                    $t("COMMON.NO_ACCOUNT")
                    }}
                  </span>
                </tk-btn>
                <tk-btn
                  v-if="!showForgotPassword"
                  flat
                  small
                  @click="
                    showForgotPassword = true;
                    error = null;
                  "
                >
                  <span class="caption text-none">
                    {{
                    $t("COMMON.FORGOT_PASSWORD")
                    }}
                  </span>
                </tk-btn>
                <tk-btn
                  v-else
                  flat
                  small
                  @click="
                    showForgotPassword = false;
                    error = null;
                  "
                >
                  <span class="caption text-none">
                    {{
                    $t("COMMON.LOGIN")
                    }}
                  </span>
                </tk-btn>
              </v-flex>
              <v-flex sm2 text-xs-right>
                <tk-btn :loading="loading" color="primary" type="submit">Ok</tk-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import TermsDialog from "@/components/terms/TermsDialog.vue";
export default {
  props: ["value", "toRedirect", "title"],

  components: { TermsDialog },

  data() {
    return {
      showForgotPassword: false,
      resetSuccess: false,
      showTermsDialog: false,
      loading: false,
      form: {},
      error: null,
      termsType: "buyer",
    };
  },

  methods: {
    close() {
      this.$emit("input", !this.value);
      this.$emit('update:title', '')
    },
    async submit() {
      this.error = null;
      this.loading = true;
      try {
        if (!this.showForgotPassword) {
          const res = await this.$auth.login(
            this.form.email,
            this.form.password
          );
          this.close();

          console.log(res);

          if (res.isArtist) {
            this.termsType = "artist";
          }

          console.log(this.$route.name);

          // Redirect artist to profile page if not in exluded routes
          // TODO Probablly not best way to implement this but for time being lets go with this
          const excludedRoutes = [
            "checkout",
            "giftcard.checkout",
            "artist.artwork",
            "artist.artwork.test",
            "profile.account",
          ];
          if (!excludedRoutes.includes(this.$route.name)) {
            this.$router.push({ name: "profile.account" });
          }

          if (!res.isLatestTermsAccepted) {
            this.showTermsDialog = true;
          }
        } else {
          await this.$auth.resetPassword(this.form.email);
          this.resetSuccess = true;
        }
      } catch (e) {
        if (e.status === 422) {
          this.error = { message: e.data.errors.email[0] };
        } else {
          this.error = e.data;
        }
      }
      this.loading = false;
    },

    async onTermsDialogClose(termId) {
      this.showTermsDialog = false;
      console.log(termId);
      if (!termId) {
        this.$router.replace({ name: "home" });
        this.$auth.logout();
      }
    },
  },
};
</script>

